import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import fetchUtil from '../../utils/fetchUtil';
import type { GetStaticPaths, GetStaticProps } from 'next';
import Universities from '../../components/Universities';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import { CACHE_REVALIDATE } from '../../utils/constants';

const UniversitiesLanding: React.FC = (props: any) => {
  const router = useRouter();
  const { page } = router.query;

  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty('--navbar-color', '#313145');
    customStyle.setProperty('--navbar-menu-color', '#ffff');
  }, []);

  const pageNumber = page ? `page-${page}` : 'page-1';

  return (
    <>
      <MetaTagsComp {...props.pageData.meta} />
      <Universities {...props} pageNumber={pageNumber} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  let pageData;
  let universityCountries;
  let countryFaqsData;

  try {
    pageData = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/universities-landing`,
      'GET',
      {},
      '',
      false
    );
  } catch (error) {
  }

  try {
    universityCountries = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/university-countries?_sort=priority`,
      'GET',
      {},
      '',
      false
    );
  } catch (error) {
  }

  try {
    countryFaqsData = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/university-countries-faqs`,
      'GET',
      {},
      '',
      false
    );
  } catch (error) {
  }

  return {
    props: {
      pageData: pageData || null,
      universityCountries: universityCountries || null,
      countryFaqsData: countryFaqsData || null,
    },
    revalidate: CACHE_REVALIDATE
  };
};

export default UniversitiesLanding; 